export const ConfigData = {
  IS_NCD_NOT_AVAILABLE: parseInt(localStorage.getItem('isNCDNotAvailable'))
};

export const getABData = (string) => {
  if (ConfigData.IS_NCD_NOT_AVAILABLE) {
    let zeroPass = string.replace(' and Anomalies', '');
    let zeroPass1 = zeroPass.replace(' and anomalies', '');
    let firstPass = zeroPass1.replace(/\s*?\/\s*?Anomaly\s*/, ' ');
    return firstPass.replace(/\s*?&\s*?Anomalies\s*/, '');
  } else {
    return string;
  }
};
